import type { ReactElement } from 'react';
import { CalendarPage } from '../../pages/CalendarPage';

/**
 * Calendar adapted into the mobile shell.
 * Same page as desktop; shell provides viewport height.
 */
export function MobileCalendarTab(): ReactElement {
  return (
    <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <CalendarPage />
    </div>
  );
}
